/**
 * Design Tokens for Haven Realty Capital Theme
 * 
 * Extends the base blue-haven theme tokens with Haven Realty Capital branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-blue-haven/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Haven Realty Capital brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Body / muted copy across intros and content sections
    text: '#1A1A1A',
    textMuted: '#1A1A1A',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    heading: "'DM Serif Display', serif",
    body: '"Poppins", sans-serif',
  },
};

export default tokens;
